import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Megaphone, Send } from 'lucide-react';
import { api } from '../lib/api';
import { Button } from './ui/button';

export const RebrandBroadcast = () => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => { api.get('/admin/broadcast/rebrand/preview').then(({ data }) => setP(data)).catch(() => {}); }, []);

  const send = async () => {
    if (!window.confirm(`Envoyer l'annonce JOTALY à ${p.emails} e-mail(s), ${p.sms} SMS et ${p.users} notification(s) ?`)) return;
    setBusy(true);
    try { const { data } = await api.post('/admin/broadcast/rebrand'); setSent(data); toast.success(`Annonce envoyée : ${data.emailed} e-mails, ${data.sms} SMS, ${data.notified} notifications`); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Erreur'); }
    setBusy(false);
  };

  return (
    <section className="card-elev rounded-2xl p-5" data-testid="rebrand-broadcast">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display text-xl font-bold flex items-center gap-2"><Megaphone className="h-5 w-5 text-[#FFD400]" />Annonce « SenegalShopLive devient JOTALY »</h2>
          <p className="text-sm text-slate-400 mt-1" data-testid="rebrand-counts">
            {p ? `${p.users} utilisateur(s) · ${p.emails} e-mail(s) · ${p.sms} SMS (comptes sans e-mail) · notification + push dans l'appli` : 'Chargement…'}
          </p>
        </div>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" data-testid="rebrand-preview-btn" onClick={() => setShowPreview(!showPreview)} className="border-slate-700 text-slate-100 bg-transparent">
            {showPreview ? 'Masquer' : 'Aperçu e-mail'}
          </Button>
          <Button size="sm" data-testid="rebrand-send-btn" disabled={busy || !p || !!sent} onClick={send} className="btn-yellow font-bold">
            <Send className="h-4 w-4 mr-1" />{sent ? 'Envoyée ✓' : 'Envoyer à tous'}
          </Button>
        </div>
      </div>
      {showPreview && p && <iframe title="aperçu" srcDoc={p.html} className="mt-4 w-full h-[420px] rounded-xl bg-white" data-testid="rebrand-preview-frame" />}
    </section>
  );
};
